import { render, staticRenderFns } from "./devolverPedidoModal.vue?vue&type=template&id=26fb5c35&scoped=true&"
import script from "./devolverPedidoModal.vue?vue&type=script&lang=js&"
export * from "./devolverPedidoModal.vue?vue&type=script&lang=js&"
import style0 from "./devolverPedidoModal.vue?vue&type=style&index=0&id=26fb5c35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb5c35",
  null
  
)

export default component.exports